import { EsocApplication, getEnvironment } from '~/nasa_ui/types';
import { CosmicSystem, EsocApplicationConfigMap } from '~/nasa_ui/types/cosmic/system';
// Defining system config which is used for example by routing
export const COSMIC_SYSTEM = CosmicSystem.ESOC;
export const COSMIC_APPLICATION = EsocApplication.LOGISTICS;
export const COSMIC_ENVIRONMENT = getEnvironment();
export const COSMIC_APPLICATION_CONFIGURATION = EsocApplicationConfigMap[COSMIC_APPLICATION];
